import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import Color from 'color';
import Loading from '../Loading';
import styles from './FlatButton.css';

const FlatButton = ({
    children,
    className,
    icon: Icon,
    iconProps,
    primaryColor,
    style,
    type,
    disabled,
    loading,
    loadingSize,
    dispatch, // eslint-disable-line
    iconAfter,
    setHover,
    hover,
    el,
    ...props
}) => {
    let color = (loading || disabled) ? '#666' : primaryColor;
    if (hover && !loading && !disabled) {
        color = Color(color).blacken(0.4).hex();
    }
    const icon = Icon ? (<Icon
        fill={color}
        {...iconProps}
    />) : null;
    let before;
    let after;
    const loadingIcon = (loading ? (<Loading
        style={{
            marginRight: '14px',
        }}
        color={color}
        size={loadingSize}
    />) : icon);
    if (iconAfter) {
        after = loadingIcon;
    } else {
        before = loadingIcon;
    }
    const isLink = props.to || props.href;
    let ButtonEl = el;
    if (props.to) {
        ButtonEl = Link;
    } else if (props.href) {
        ButtonEl = 'a';
    }

    const elementType = isLink ? undefined : type;
    return (<ButtonEl
        className={cx(styles.button, {
            [styles.after]: iconAfter,
        }, className)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
            color,
            cursor: disabled ? 'default' : 'pointer',
            ...style,
        }}
        type={elementType}
        disabled={disabled || loading}
        {...props}
    >
        {before}
        {children}
        {after}
    </ButtonEl>);
};

FlatButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    primaryColor: PropTypes.string,
    href: PropTypes.string,
    icon: PropTypes.func,
    iconProps: PropTypes.object,
    style: PropTypes.object,
    iconAfter: PropTypes.bool,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    loadingSize: PropTypes.number,
    to: PropTypes.string,
    setHover: PropTypes.func,
    hover: PropTypes.bool,
    el: PropTypes.string,
};

FlatButton.defaultProps = {
    iconProps: {
        size: 18,
    },
    loadingSize: 16,
    style: {},
    type: 'button',
    el: 'button',
};

export default compose(
    connect(({ theme }, { color }) => ({
        primaryColor: color || theme.primaryColor,
    })),
    withState('hover', 'setHover', false),
)(FlatButton);



// WEBPACK FOOTER //
// ./src/client/Components/FlatButton/FlatButton.js